/** Selo da companhia: nome e código nas cores da companhia (sem logotipo). */
const SELOS: Record<string, { nome: string; classe: string }> = {
  G3: { nome: 'GOL', classe: 'gol' },
  LA: { nome: 'LATAM', classe: 'latam' },
  JJ: { nome: 'LATAM', classe: 'latam' },
  AD: { nome: 'Azul', classe: 'azul' },
  TP: { nome: 'TAP', classe: 'tap' },
};

export function CiaSelo({ companhia, nome, tamanho = 'md' }: { companhia: string; nome?: string; tamanho?: 'sm' | 'md' }) {
  const cod = companhia.toUpperCase();
  const s = SELOS[cod];
  const rotulo = s?.nome ?? nome ?? cod;
  return (
    <span className={`cia-selo cia-selo--${s?.classe ?? 'outra'} cia-selo--${tamanho}`} title={`${rotulo} (${cod})`} aria-label={`${rotulo} (${cod})`}>
      <span className="cia-selo__nome" aria-hidden="true">
        {rotulo.length > 6 ? cod : rotulo}
      </span>
      <span className="cia-selo__cod" aria-hidden="true">
        {cod}
      </span>
    </span>
  );
}

/** Avião (ícone genérico) para a linha da rota. */
export function IconeAviao({ size = 18 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M21 15.5v-1.7l-8-5V3.5a1.5 1.5 0 0 0-3 0v5.3l-8 5v1.7l8-2.5v5.3l-2 1.5V21l3.5-1 3.5 1v-1.2l-2-1.5V13l8 2.5z" transform="rotate(90 12 12)" />
    </svg>
  );
}
